module.exports = __webpack_public_path__ + "static/media/arrow.min.878c817e.svg";